module.exports = __webpack_public_path__ + "static/media/Flag_Japan.3ee67ac3.svg";